/**
 * Central manifest for all routes in the application
 */
export enum Routes {
    home = "/",
    vaultListing = "/vaults",
    vaultIndividual = "/vaults/:vaultID",
    vaultIndividualAsWallet = "/vaults/:vaultID/wallet/:walletID",
}
